import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const DUPLICATE_TODO_SUCCESS = "DUPLICATE_TODO_SUCCESS";
export const DUPLICATE_TODO_ERROR = "DUPLICATE_TODO_ERROR";

// Thunk Action Creator
export const duplicateTodo = createAsyncThunk(
    "api/Task/duplicateTodo",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.post(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/duplicateTodo/`,
                    { todos: json.todos },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                //.then(response => {
                //    dispatch({
                //        type: DUPLICATE_TODO_SUCCESS,
                //        payload: response.data,
                //    });
                //    dispatch(getLatestTaskList());
                //})
                //.catch(error => {
                //    dispatch({ type: DUPLICATE_TODO_ERROR, payload: error });
                //});
                //Check for response 
                //Store API result into indexed DB
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error duplicating task");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: DUPLICATE_TODO_SUCCESS,
                    payload: response.data
                });
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: DUPLICATE_TODO_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: DUPLICATE_TODO_ERROR, payload: error });
            await signOut();
        }
    }
);
